module.exports = __webpack_public_path__ + "media/assets/images/kousaku-cloud-logo-black-f9d84210270994b1d97b49a8a1e0a55c.png";